export const DELETE_NULL_FILES_REQUEST = "DELETE_NULL_FILES_REQUEST"
export const DELETE_NULL_FILES_REQUEST_REQUEST = "DELETE_NULL_FILES_REQUEST_REQUEST"
